module.exports = __webpack_public_path__ + "static/BT-desktop-2-c2166b46684a17cebc50529efd6c5576.jpg";